export default __webpack_public_path__ + "static/media/arthur.070588ce.jpg";